// JOBE-0167.1: CedarCapabilityChip — operator-permission indicator.
//
// Three render states from the supplied `state` prop:
//   - { permitted: true }                           → "<cap> · ✓"
//   - { permitted: true, requiresApproval: true }   → "<cap> · ✓ · approval required"
//   - { permitted: false }                          → "<cap> · ✗"
//
// Renders as a <PillChip /> (JOBE-0158.3) plus a data attribute the
// tests / styles can read. The PillChip primitive is colour-neutral;
// the denial styling rides on data-state="denied" so we don't have
// to fork the primitive.
//
// JOBE-0167.4 wires the live capability lookup via
// useCedarCapabilities(); v1 accepts a static map for tests.

import { PillChip } from '../../components/PillChip/PillChip.jsx';

/**
 * @param {object} props
 * @param {string} props.capability   Cedar capability key, e.g. "memory:forget"
 * @param {{permitted: boolean, requiresApproval?: boolean}} [props.state]
 *        When omitted, the chip renders as denied — strict default.
 */
export function CedarCapabilityChip({ capability, state }) {
  const resolved = state || { permitted: false };
  const permitted = resolved.permitted === true;
  const approvalRequired = permitted && resolved.requiresApproval === true;

  let label = `${capability} · ${permitted ? '✓' : '✗'}`;
  if (approvalRequired) label += ' · approval required';

  // data-state lets styles fork without touching the PillChip primitive.
  const dataState = !permitted
    ? 'denied'
    : approvalRequired
      ? 'approval-required'
      : 'permitted';

  return (
    <span
      className="cedar-capability-chip"
      data-state={dataState}
      data-capability={capability}
      data-testid={`cedar-chip-${capability}`}
    >
      <PillChip label={label} />
    </span>
  );
}

export default CedarCapabilityChip;
